import { lowerBoundMinVisibleDistance } from 'reducers/positions';
import { createSelector } from 'reselect';

export const zoomForMap = createSelector(
  [(state, { mapId }) => state.positions.maps[mapId]?.minVisibleDistance || lowerBoundMinVisibleDistance],
  zoom => zoom,
  { memoizeOptions: { maxSize: 10 } }
);
